'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { ESCAPE_KEYCODE } from '../../util/keycodes.js';
import { Button } from '../../index.js';
export const ShowHide = (_a) => {
    var { align, type, buttonVariant, iconName, hideButton, iconPosition, className, text, closeText, children } = _a, other = __rest(_a, ["align", "type", "buttonVariant", "iconName", "hideButton", "iconPosition", "className", "text", "closeText", "children"]);
    const [isActive, setIsActive] = React.useState(false);
    const dropdownRef = React.useRef(null);
    const handleClick = () => setIsActive(!isActive);
    React.useEffect(() => {
        document.addEventListener('mousedown', handleOnClickOutside, false);
        document.addEventListener('touchstart', handleOnClickOutside, false);
        return () => {
            document.removeEventListener('mousedown', handleOnClickOutside, false);
            document.removeEventListener('touchstart', handleOnClickOutside, false);
        };
    }, []);
    const handleOnClickOutside = (event) => {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target)) {
            setIsActive(false);
        }
    };
    function handleOnKeyDown(e) {
        if (e.code === ESCAPE_KEYCODE) {
            setIsActive(false);
        }
    }
    const componentClassName = classnames('sparky-c-show-hide', className, {
        'sparky-is-active': isActive,
        'sparky-c-show-hide--align-right': align === 'right',
        'sparky-c-show-hide--align-top-right': align === 'top-right',
        'sparky-c-show-hide--align-top-left': align === 'top-left',
    });
    return (_jsxs("div", Object.assign({ className: componentClassName, ref: dropdownRef }, other, { onKeyDown: handleOnKeyDown }, { children: [_jsx(Button, { "aria-expanded": isActive ? 'true' : 'false', className: hideButton && isActive
                    ? 'sparky-c-show-hide__button sparky-u-is-hidden'
                    : 'sparky-c-show-hide__button', variant: buttonVariant, type: type, iconPosition: iconPosition, iconName: iconName, text: isActive ? closeText || text : text, onClick: handleClick }), _jsx("div", Object.assign({ className: "sparky-c-show-hide__panel", hidden: !isActive }, { children: children }))] })));
};
//# sourceMappingURL=ShowHide.js.map